/**
 * Maps worklist type to the process type name stored in VOB assignments.
 * This function is shared between UserAssignmentSummary and BenefitsWorklist
 * to ensure consistent mapping of worklist types to process types.
 * 
 * @param worklistType - The type of worklist (e.g., 'Benefits', 'Authorization')
 * @returns The corresponding process type name for VOB assignments
 */
export function getProcessType(worklistType: string): string {
    if (worklistType === 'Benefits' || worklistType === 'AdecBenefits') return 'Verifications';
    if (worklistType === 'Authorization' || worklistType === 'Authorization Denied') return 'Authorizations';
    return worklistType;
}
